// src/slices/2-location/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// 🟢 Create New Location
export const createLocation = createAsyncThunk("location/createLocation", async (locationData, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    const token = tokenData?.data?.token;

    const response = await axios.post(`${API_URL}/location`, locationData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });

    return response.data.data || [];
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to create location");
  }
});

// 🟡 Update Location
export const updateLocation = createAsyncThunk("location/updateLocation", async ({ id, updatedData }, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    const token = tokenData?.data?.token;

    const response = await axios.put(`${API_URL}/location/${id}`, updatedData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
    return response.data.data || [];
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to update location");
  }
});

// 🔵 Get All Locations
export const getAllLocations = createAsyncThunk("location/getAllLocations", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/location`);

    return response.data.data || [];
  } catch (error) {
    console.error("❌ Error fetching locations:", { data: error.response?.data, status: error.response?.status, headers: error.response?.headers, message: error.message });

    return rejectWithValue(error?.response?.data?.message || "Failed to fetch locations");
  }
});

// 🟣 Get One Location
export const getLocationById = createAsyncThunk("location/getLocationById", async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/location/${id}`);

    const data = response.data.data?.[0] || null;
    return data;
  } catch (error) {
    console.error("❌ Error fetching location:", error);
    return rejectWithValue(error?.response?.data.data?.message || "Failed to fetch location");
  }
});
// 🔴 Delete Location
export const deleteLocation = createAsyncThunk("location/deleteLocation", async (id, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    const token = tokenData?.data?.token;

    const response = await axios.delete(`${API_URL}/location/${id}`, { headers: { Authorization: `Bearer ${token}` } });

    return { id, message: response.data?.message || "Location deleted" };
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to delete location");
  }
});
